<template>
    <v-flex xs12 class="mt-4 pt-0">
      <v-card>
        <v-card-title class="head">
          <v-layout row wrap>
            <v-flex xs12>
              <span class="title">Battery Chart</span>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text class="body">
            <line-chart :datasets="datasets" :labels="labels" :options="options" :height="400"></line-chart>
        </v-card-text>
      </v-card>
    </v-flex>
</template>

<script>
  import LineChart from '@/components/customized-components/LineChart';

  export default {
    // extends: Line,
    props: ['datasets', 'labels', 'options'],
    components: { LineChart },
    mounted() {
      // document.getElementById("myBtn").style.height = "50px";
      // document.getElementById('line-chart').style.height = '50px';
    },
  };
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px !important;
  font-weight: 800;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/customized-components/Battery.vue